import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'nprogress/nprogress.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
// import 'sweetalert2/dist/sweetalert2.min.css';
import "../theme/sweetalert.scss";
// import "../theme/default.styl";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#0092C9", // Cor de foco no input
        secondary: "#424242",
        accent: "#C4170C",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
  customProperties: true,
});
